"use strict";

exports.__esModule = true;
exports["default"] = isNumberValid;

var _cramda = _interopRequireDefault(require("cramda"));

var _countryTelephoneData = _interopRequireDefault(require("country-telephone-data"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function isNumberValid(inputNumber) {
  var countries = _countryTelephoneData["default"].allCountries;
  return _cramda["default"].any(function (country) {
    return _cramda["default"].startsWith(country.dialCode, inputNumber) || _cramda["default"].startsWith(inputNumber, country.dialCode);
  }, countries);
}

module.exports = exports.default;